import "./IconArrowBoxRight.scss";
import { ReactComponent as ArrowBoxRightSVG } from "./svg/icon-arrow-box-right.svg";

interface Props {
  color?: "black" | "blue";
}

export const IconArrowBoxRight = ({ color = "black" }: Props) => {
  return (
    <div className={`icon-arrow-box-right icon-arrow-box-right--${color}`}>
      <ArrowBoxRightSVG />
    </div>
  );
};
